// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"295":"49190e98","534":"c36d4b04"}[chunkId] + ".chunk.css";
};